<ng-container *ngIf="value">
    <options class="nomenu" [optionstrip]="options" (clickOption)="onClickOption($event)">
    </options>
    <shared-route-part-cmr-digitaldocument-component class="nosignatures" [external]="true" [routePartCMRId]="getRoutePartCMRID()"
        [readonly]="true" [avoidOptionFirma]="true" [contract]="contract" 
        *ngIf="getRoutePartCMRID()>0"></shared-route-part-cmr-digitaldocument-component>
    <ng-container *ngIf="value.signable">
        <div class="sign-line">{{'GLOBAL.SIGN'|translate}}</div>
        <shared-sign-cmr-maintenance [signUUID]="uuid" [type]="agent"
            (signedChanged)="onSignedChanged()">
            <!-- Re-projectem les accions addicionals que ens passi el pare -->
            <ng-container ngProjectAs="[sign-extra-actions]">
                <ng-content select="[sign-extra-actions]"></ng-content>
            </ng-container>
        </shared-sign-cmr-maintenance>
    </ng-container>
    <div class="dummy">
        dummy
    </div>
</ng-container>